import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-issue',
  templateUrl: './issue.component.html',
  styleUrls: ['./issue.component.less']
})
export class IssueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
